import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as Constants from '@emi/shared/constants';
import { HttpService } from '../http.service';
import { CategoryDto } from '@emi/shared/models';

@Injectable({
    providedIn: 'root',
})
export class CategoryService {
    constructor(private httpService: HttpService) {}

    public getCategories(filterData: object): Observable<CategoryDto> {
        return this.httpService.postHttp<CategoryDto>(Constants.ServiceConstants.CATEGORIES, filterData);
    }
}
